var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.83331H4.16667C3.24619 5.83331 2.5 6.57951 2.5 7.49998V14.1666C2.5 15.0871 3.24619 15.8333 4.16667 15.8333H15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1666V7.49998C17.5 6.57951 16.7538 5.83331 15.8333 5.83331Z",
    stroke: "#667085",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 9.99998L8.50917 10.0883C8.97205 10.3198 9.48247 10.4403 10 10.4403C10.5175 10.4403 11.0279 10.3198 11.4908 10.0883L11.6667 9.99998M7.5 4.99998C7.5 4.55795 7.6756 4.13403 7.98816 3.82147C8.30072 3.50891 8.72464 3.33331 9.16667 3.33331H10.8333C11.2754 3.33331 11.6993 3.50891 12.0118 3.82147C12.3244 4.13403 12.5 4.55795 12.5 4.99998V5.83331H7.5V4.99998Z",
    stroke: "#667085",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.04d4cac5313e65e206bccf00161ccbd1.svg";
export { ForwardRef as ReactComponent };